import React from 'react';
import { Dialog, Typography } from '@genie-ui/react';
import PropTypes from 'prop-types';

function DialogComponent({
  handleClose,
  open,
  title,
  modalClass,
  modalRootClass,
  content,
  hideCloseButton,
}) {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      title={title}
      className={modalClass}
      classNameRoot={modalRootClass}
      hideCloseButton={hideCloseButton}
      disableBackdropClickClose
    >
      <Typography variant="body1">
        {content}
      </Typography>
    </Dialog>
  );
}

DialogComponent.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.instanceOf(Object),
  modalClass: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  modalRootClass: PropTypes.string,
};

DialogComponent.defaultProps = {
  open: false,
  handleClose: () => {},
  title: '',
  content: '',
  modalClass: '',
  hideCloseButton: false,
  modalRootClass: '',
};

export default DialogComponent;
